'use strict';

import cookies from 'js-cookie';
import config from '../utils/config.js';

const parkersPrefix = 'Parkers.';

const cookieNames = {
	cfsPreferences: parkersPrefix + 'CFS',
	cfsShortlist: parkersPrefix + 'CFS.Shortlist',
	geoLocation: parkersPrefix + 'Geolocation',
	session: parkersPrefix + 'Session',
	user: parkersPrefix + 'User',
	newsletterSignup: 'newsletter-signup',
	permutiveUserEmailHash: 'permutive-user-email-hash'
};

const cookieDurations = {
	cfsShortlist: 365,
	user: 365
}

const writeCookie = (cookieName, cookieData) => {
	const options = {
		domain: config.cookieDomain
	};

	if (typeof cookieData === "object") {
		cookieData = JSON.stringify(cookieData);
	}

	cookies.set(cookieName, cookieData, options);
}

export default {
	deleteCookie: function (cookieName) {
		cookies.remove(cookieName, {
			domain: config.cookieDomain
		});
	},

	getCookie: function (cookieName) {
		const cookieData = cookies.get(cookieName);

		if (cookieData) {
			try {
				return JSON.parse(cookieData);
			}
			catch (e) {
				console.log("Cannot parse cookie as JSON " + e);
				return cookieData;
			}
		}

		return undefined;
	},

	setCookie: function (cookieName, cookieData) {
		writeCookie(cookieName, cookieData);
	},

	names: cookieNames,
	durations: cookieDurations
};